module.exports = __webpack_public_path__ + "static/media/CT.eb5e45c6.jpg";